import trimEnd from 'lodash/trimEnd'

export function removeUnit(str, unit) {
  return parseFloat(trimEnd(str, unit));
}



// WEBPACK FOOTER //
// ./src/tools/unit.js